import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Card, CardBody, Col, Row, Input } from 'reactstrap';
import { getCorprateUrl } from '../../../shared/components/domainSupport';
import { jsonHeader, serverUrl, isProdEnv } from '../../../config';
import LoadingSpinner from '../../../shared/components/widgets/LoadingSpinner';
import Alert from '../../../shared/components/Alert';
import FilterSelect from '../../../shared/components/filters/FilterSelect';

const CreateAccount = () => {
  // const selectedAccount = useSelector(store => store.sellerSelect);
  const user = useSelector(store => store.authentication.user);
  const [accountName, setAccountName] = useState('');
  const [accountDescription, setAccountDescription] = useState('');
  const [customer, setCustomer] = useState({});
  const [customerOptions, setCustomerOptions] = useState([]);
  const [parentAccount, setParentAccount] = useState({});
  const [parentAccountOptions, setParentAccountOptions] = useState([]);
  const [devAccountId] = useState('0'); // This was the old MWS and we can re-tool or remove
  const [accountType, setAccountType] = useState({});
  const [accountTypeOptions, setAccountTypeOptions] = useState([]);
  const [marketplace, setMarketplace] = useState({}); // 3 is US and can be set as default
  const [marketplaceOptions, setMarketplaceOptions] = useState([]);
  const [agency, setAgency] = useState({});
  const [agencyOptions, setAgencyOptions] = useState([]);
  const [platform, setPlatform] = useState({});
  const [platformOptions, setPlatformOptions] = useState([]);
  const [accountStatus] = useState('active');
  const [loading, setLoading] = useState(false);
  const [localAlert, setLocalAlert] = useState({});

  useEffect(() => {
    setLoading(true);
    const headerWithAuth = { ...jsonHeader, authorization: `JWT ${user?.jwtToken}` };
    // Add logic to check input values, make sure they are present and correct.
    const specsOptions = {
      method: 'GET',
      headers: headerWithAuth,
    };

    const specsUrl = `${serverUrl}/accounts/specs`;
    fetch(specsUrl, specsOptions)
      .then(async (results) => {
        if (!results.ok) {
          const text = await results.text();
          throw new Error(text);
        }
        return results.json();
      }).then((data) => {
        if (!isProdEnv) {
          console.info(data);
        }

        const newCustomerOptions = [];
        data.customerData.forEach(cust => {
          newCustomerOptions.push({ label: `${cust.customer_name} (${cust.customer_id} - ${cust.customer_email})`, value: cust.customer_id })
        })
        setCustomerOptions(newCustomerOptions);

        const newParentAccountOptions = [];
        data.parentAccountData.forEach(pa => {
          newParentAccountOptions.push({ label: `${pa.seller_account_name} (${pa.seller_account_id})`.replace('**** SYSTEM **** (1)', 'NONE'), value: pa.seller_account_id })
        })
        setParentAccountOptions(newParentAccountOptions);

        const newAccountTypeOptions = [];
        data.accountTypeData.forEach(at => {
          newAccountTypeOptions.push({ label: at.seller_account_type_name.replace('AMAZON SELLER CENTRAL', 'SELLER/3p/MARKETPLACE').replace('AMAZON VENDOR CENTRAL', 'VENDOR/1p/SUPPLIER').replace('AMAZON AGENCY', 'LIMITLESS ONLY DSP/ATTRIBUTION'), value: at.seller_account_type_id })
        })
        setAccountTypeOptions(newAccountTypeOptions);

        const newMarketplaceOptions = [];
        data.marketplaceData.forEach(mp => {
          newMarketplaceOptions.push({ label: `${mp.marketplace_name} - ${mp.marketplace_description}`, value: mp.marketplace_id })
        })
        setMarketplaceOptions(newMarketplaceOptions);

        const newAgencyOptions = [];
        data.agencyData.forEach(a => {
          newAgencyOptions.push({ label: a.name, value: a.code })
        })
        setAgencyOptions(newAgencyOptions);
        const newPlatformOptions = [];
        data.platformData.forEach(p => {
          newPlatformOptions.push({ label: p.name, value: p.code })
        })
        setPlatformOptions(newPlatformOptions);
      }).catch((error) => {
        setLocalAlert({ color: 'danger', message: JSON.stringify(error) });
        console.error(error);
      });
    setLoading(false);
  }, []);


  const createAccount = () => {
    setLoading(true);
    if (accountName !== '' && customer.value && parentAccount.value && accountType.value && marketplace.value && agency.value && platform.value) {
      const headerWithAuth = { ...jsonHeader, authorization: `JWT ${user?.jwtToken}` };
      // Add logic to check input values, make sure they are present and correct.
      const accountOptions = {
        method: 'POST',
        headers: headerWithAuth,
        body: JSON.stringify({
          name: accountName,
          description: accountDescription,
          customerId: customer.value,
          parentAccountId: parentAccount.value === 1 ? 0 : (parentAccount.value || 0),
          devAccountId, // This was the old MWS and we can re-tool or remove
          typeId: accountType.value,
          marketplaceId: marketplace.value,
          agency: agency.value,
          platform: platform.value,
          status: accountStatus,
        }),
      };

      const createAccountUrl = `${serverUrl}/accounts`;
      fetch(createAccountUrl, accountOptions)
        .then(async (results) => {
          if (!results.ok) {
            const text = await results.text();
            throw text;
          }
          return results.json();
        }).then((data) => {
          if (!isProdEnv) {
            console.info(data);
          }

          const row = Array.isArray(data) ? data[0] : data;

          setLocalAlert({ color: 'primary', message: `Account Created - AID: ${row.seller_account_id}, EAID: ${row.external_account_id}` });
          setAccountName('');
          setAccountDescription('');
          setCustomer({});
          setParentAccount({});
          setAccountType({});
          setMarketplace({});
          setAgency({});
          setPlatform({});
        }).catch((error) => {
          const message = typeof myVariable === 'object' ? JSON.stringify(error) : error;
          setLocalAlert({ color: 'danger', message });
        });
    } else {
      setLocalAlert({ color: 'danger', message: 'Please fill in required fields' });
    }
    setLoading(false);
  }

  return (
    <Col md={12}>
      <Card>
        <Row>
          <Col md={5}>
            <CardBody>
              <LoadingSpinner active={loading} />
              {!loading && (
                <>
                  <div className="form__form-group">
                    {localAlert && localAlert.message && (
                      <Alert color={localAlert.color}>{localAlert.message}</Alert>
                    )}
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Account Name</span>
                    <div className="form__form-group-field">
                      <Input
                        autoFocus
                        name="accountName"
                        component="input"
                        type="text"
                        value={accountName}
                        onChange={(e) => setAccountName(e.target.value)}
                      />
                    </div>
                    {localAlert.message && localAlert.color !== 'primary' && (!accountName || accountName === '') && (
                      <div className="form__form-group-error">Account Name is required</div>
                    )}
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Account Description</span>
                    <div className="form__form-group-field">
                      <Input
                        autoFocus
                        name="accountDescription"
                        component="input"
                        type="text"
                        value={accountDescription}
                        onChange={(e) => setAccountDescription(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Customer</span>
                    <div className="form__form-group-field">
                      <FilterSelect
                        selectClass="dropdown__select"
                        onChange={setCustomer}
                        options={customerOptions}
                        selected={customer}
                        disable={loading}
                      />
                    </div>
                    {localAlert.message && localAlert.color !== 'primary' && (!customer.value) && (
                      <div className="form__form-group-error">Customer is required</div>
                    )}
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Parent Account</span>
                    <div className="form__form-group-field">
                      <FilterSelect
                        selectClass="dropdown__select"
                        onChange={setParentAccount}
                        options={parentAccountOptions}
                        selected={parentAccount}
                        disable={loading}
                      />
                    </div>
                    {localAlert.message && localAlert.color !== 'primary' && (!parentAccount.value) && (
                      <div className="form__form-group-error">Selection required, select NONE for no parent (most common)</div>
                    )}
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Account Type</span>
                    <div className="form__form-group-field">
                      <FilterSelect
                        selectClass="dropdown__select"
                        onChange={setAccountType}
                        options={accountTypeOptions}
                        selected={accountType}
                        disable={loading}
                      />
                    </div>
                    {localAlert.message && localAlert.color !== 'primary' && (!accountType.value) && (
                      <div className="form__form-group-error">Account Type is required</div>
                    )}
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Marketplace</span>
                    <div className="form__form-group-field">
                      <FilterSelect
                        selectClass="dropdown__select"
                        onChange={setMarketplace}
                        options={marketplaceOptions}
                        selected={marketplace}
                        disable={loading}
                      />
                    </div>
                    {localAlert.message && localAlert.color !== 'primary' && (!marketplace.value) && (
                      <div className="form__form-group-error">Marketplace is required</div>
                    )}
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Agency</span>
                    <div className="form__form-group-field">
                      <FilterSelect
                        selectClass="dropdown__select"
                        onChange={setAgency}
                        options={agencyOptions}
                        selected={agency}
                        disable={loading}
                      />
                    </div>
                    {localAlert.message && localAlert.color !== 'primary' && (!agency.value) && (
                      <div className="form__form-group-error">Agency is required</div>
                    )}
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Platform</span>
                    <div className="form__form-group-field">
                      <FilterSelect
                        selectClass="dropdown__select"
                        onChange={setPlatform}
                        options={platformOptions}
                        selected={platform}
                        disable={loading}
                      />
                    </div>
                    {localAlert.message && localAlert.color !== 'primary' && (!platform.value) && (
                      <div className="form__form-group-error">Platform is required</div>
                    )}
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Account State</span>
                    <div className="form__form-group-field">
                      <Input
                        autoFocus
                        name="accountStatus"
                        component="input"
                        type="text"
                        value={accountStatus}
                        disabled
                      />
                    </div>
                  </div>
                  <br />
                  <div className="form__form-group">
                    <button className="btn btn-primary account__btn" type="submit" disabled={loading} onClick={() => createAccount()}>Create Account</button>
                  </div>
                </>
              )}
            </CardBody>
          </Col>
          <Col md={5}>
            <CardBody>
              <br />
              <p>PLEASE NOTE:<br /><br /></p>
              <blockquote><p>This will create a new account without any connections to AD services</p></blockquote>
              <br />
              <blockquote><p>Please onboard a AD service and supporting APIs after you have succesfully created an account</p></blockquote>
              <br />
              <blockquote><p>By Clicking &apos;Create Account&apos;, you agree to our <a href={`${getCorprateUrl()}/terms-of-use`} rel="noopener noreferrer" target="_blank">Terms &amp; Conditions</a></p></blockquote>
              <br />
            </CardBody>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default CreateAccount;
